module.exports = __webpack_public_path__ + "static/media/woman-red-tiles-garden.7fd7099d.jpg";